// Firm-branded animated gradient backdrop for client-facing surfaces.
// Pulls CSS vars from the parent's inline style (set by useFirmBranding).
import styles from '../../pages/public/upload.module.css';

export default function GradientBackdrop() {
  return (
    <div className={styles.backdrop} aria-hidden="true">
      <div className={styles.grain} />
    </div>
  );
}
